module.exports = __webpack_public_path__ + "svg/ra-cons.32b74bd.svg";